import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import AvailableDividendRow from './AvailableDividendRow';
import ModifyAvailableDividend from './ModifyAvailableDividend';

export const availableDividendActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Elérhető osztalék módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => row.privateId,
        actionComponent: (props, close) => <ModifyAvailableDividend {...props} close={close} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Elérhető osztalék törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/availabledividend'} comp={<AvailableDividendRow {...props} />} />
    }
]